<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      max-width="720"
    >
      <template v-slot:activator="{ props: activatorProps }">
        <v-btn
          class="ml-1 text-none font-weight-regular"
          icon="mdi-plus"
          variant="plain"
          size="medium"
          v-bind="activatorProps"
        ></v-btn>
      </template>

      <v-card
        prepend-icon="mdi-plus"
        title="Nova Requisição de Compra"
      >
        <v-card-text>
          <v-form ref="form" @submit.prevent="createRequest">
            <v-row dense>
              <v-col
                cols="12"
                md="12"
                sm="12"
              >
                <v-text-field
                  v-model="form.description"
                  label="Descrição"
                  required
                  :rules="[v => !!v || 'Descrição é obrigatória']"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                md="6"
                sm="6"
              >
                <v-select
                  v-model="form.sectorId"
                  label="Setor"
                  :items="sectors"
                  item-title="description"
                  item-value="id"
                  required
                  :rules="[v => !!v || 'Setor é obrigatório']"
                ></v-select>
              </v-col>
              
              <v-col
                cols="12"
                md="6"
                sm="6"
              >
                <v-radio-group
                  v-model="form.priority"
                  label="Prioridade"
                  required
                  inline
                  :rules="[v => !!v || 'Prioridade é obrigatória']"
                  row
                >
                  <v-radio
                    v-for="priority in PRIORITY_TYPES"
                    :key="priority.id"
                    :label="priority.label"
                    :value="priority.id"
                    :color="priority.color"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              
              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="form.note"
                  label="Observações"
                  rows="3"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text="Cancelar"
            variant="plain"
            @click="closeDialog"
          ></v-btn>

          <v-progress-circular
            v-if="waitingServer"
            color="primary"
            indeterminate
          ></v-progress-circular>
          <v-btn
            v-else
            color="blue-darken-1"
            text="Salvar"
            variant="flat"
            :disabled="!isFormValid"
            @click="submitRequest"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.active"
      :timeout="4000"
      :color="snackbar.color"
      elevation="24"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { PRIORITY_TYPES } from '@/helpers/constants/app.constants';

export default {
  name: 'NewRequestDialog',

  data: () => ({
    dialog: false,
    waitingServer: false,
    PRIORITY_TYPES,
    form: {
      description: null,
      sectorId: null,
      priority: 'LOW',
      note: null
    },
    snackbar: {
      text: '',
      color: '',
      active: false
    }
  }),

  computed: {
    ...mapGetters('general', ['sectors']),
    
    isFormValid() {
      return this.form.description && this.form.sectorId && this.form.priority;
    }
  },

  watch: {
    dialog(newValue) {
      if (!newValue) {
        this.resetForm();
      }
    },
  },

  methods: {
    ...mapActions('request', ['createRequest']),

    snackbarHandler({color, text}) {
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.active = true;
    },

    async submitRequest() {
      if (!this.isFormValid) return;
      
      this.waitingServer = true;
      
      const { success, error } = await this.createRequest(this.form);
        
        if (success) {
          this.snackbarHandler({ color: 'success', text: 'Requisição criada com sucesso!' });
          this.closeDialog();
        } else {
          this.snackbarHandler({ color: 'error', text: `Erro ao criar requisição: ${error}` });
          this.waitingServer = false;
        }
    },

    resetForm() {
      this.form = {
        description: null,
        sectorId: null,
        priority: 'LOW',
        note: null
      };
    },

    closeDialog() {
      this.dialog = false;
      this.waitingServer = false;
    }
  }
}
</script>